// src/templates/cotizacion/TechBlue/index.jsx

// ─── Mock data para preview/modal ─────────────────────────────────────────────
export const MOCK_DATA = {
  empresa: {
    inicial: "M",
    nombre: "Mi Empresa S.A. de C.V.",
    tagline: "Soluciones Tecnológicas",
    direccion: "Calle Reforma 456, Col. Centro, CDMX",
    telefono: "+52 55 1234 5678",
    email: "ventas@miempresa.com",
    rfc: "MEM000101XYZ",
  },
  meta: {
    folio: "COT-2024-001",
    fecha: "2024-02-19",
    validez: "2024-03-19",
    estado: "PENDIENTE",
    vendedor: "María",
    proyecto: "Propuesta de servicios profesionales",
  },
  cliente: {
    nombre: "Empresa Ejemplo S.A. de C.V.",
    contacto: "Juan Pérez",
    direccion: "Av. Insurgentes Sur 1234, Col. Del Valle, CDMX",
    telefono: "+52 55 9876 5432",
    email: "contacto@empresa.com",
  },
  items: [
    {
      sku: "PROD-001",
      descripcion: "Producto de ejemplo 1",
      cantidad: "10 PZA",
      precio: "$1,000.00",
      total: "$10,000.00",
    },
    {
      sku: "PROD-002",
      descripcion: "Producto de ejemplo 2",
      cantidad: "5 PZA",
      precio: "$2,000.00",
      total: "$10,000.00",
    },
  ],
  totales: {
    subtotal: "$20,000.00",
    iva: "$3,200.00",
    total: "$23,200.00",
  },
  terminos: "Pago a 30 días",
  notas: "Gracias por su preferencia",
};

// ─── Componente ───────────────────────────────────────────────────────────────
export default function TechBlue({ data = MOCK_DATA }) {
  const { empresa, meta, cliente, items, totales, terminos, notas } = data;

  return (
    <div
      style={{
        padding: "20mm 20mm 20mm 25mm",
        fontFamily: "sans-serif",
        fontSize: "13px",
        color: "rgb(15,23,42)",
        background: "#fff",
        minWidth: "650px",
        position: "relative",
        borderLeft: "8px solid rgb(14,165,233)",
      }}
    >
      {/* ── Header empresa + tipo ── */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          marginBottom: "48px",
          borderBottom: "2px solid rgb(241,245,249)",
          paddingBottom: "24px",
        }}
      >
        {/* Empresa */}
        <div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              marginBottom: "16px",
            }}
          >
            <div
              style={{
                width: "40px",
                height: "40px",
                borderRadius: "6px",
                background: "rgb(15,23,42)",
                color: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: 700,
                fontSize: "18px",
              }}
            >
              {empresa.inicial}
            </div>
            <div>
              <h2
                style={{
                  margin: 0,
                  fontSize: "14px",
                  fontWeight: 700,
                  color: "rgb(15,23,42)",
                  lineHeight: 1,
                }}
              >
                {empresa.nombre}
              </h2>
              <p
                style={{
                  margin: "4px 0 0",
                  fontSize: "11px",
                  color: "rgb(100,116,139)",
                }}
              >
                {empresa.tagline}
              </p>
            </div>
          </div>
          <div
            style={{
              fontSize: "11px",
              color: "rgb(100,116,139)",
              lineHeight: "1.6",
            }}
          >
            <p style={{ margin: 0 }}>{empresa.direccion}</p>
            <p style={{ margin: 0 }}>
              {empresa.telefono} | {empresa.email}
            </p>
            <p style={{ margin: 0, fontFamily: "monospace" }}>{empresa.rfc}</p>
          </div>
        </div>

        {/* Tipo + folio + fecha */}
        <div style={{ textAlign: "right" }}>
          <h1
            style={{
              margin: "0 0 8px",
              fontSize: "36px",
              fontWeight: 700,
              color: "rgb(14,165,233)",
              letterSpacing: "-0.02em",
            }}
          >
            COTIZACIÓN
          </h1>
          <p
            style={{
              margin: "0 0 16px",
              fontSize: "14px",
              fontWeight: 500,
              color: "rgb(100,116,139)",
            }}
          >
            {meta.folio}
          </p>
          <div
            style={{
              display: "inline-flex",
              flexDirection: "column",
              alignItems: "flex-end",
              gap: "4px",
            }}
          >
            <div
              style={{
                padding: "4px 12px",
                borderRadius: "4px",
                background: "rgb(248,250,252)",
                color: "rgb(100,116,139)",
                fontSize: "11px",
                fontWeight: 600,
              }}
            >
              {meta.fecha}
            </div>
            <div
              style={{
                fontSize: "9px",
                color: "rgb(148,163,184)",
                textTransform: "uppercase",
                letterSpacing: "0.1em",
              }}
            >
              Fecha de Emisión
            </div>
          </div>
        </div>
      </div>

      {/* ── Cliente + Detalles ── */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          gap: "48px",
          marginBottom: "48px",
        }}
      >
        {/* Cliente */}
        <div style={{ flex: 1 }}>
          <h3
            style={{
              margin: "0 0 16px",
              fontSize: "12px",
              fontWeight: 700,
              color: "rgb(148,163,184)",
              textTransform: "uppercase",
              letterSpacing: "0.05em",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <span
              style={{
                width: "8px",
                height: "8px",
                borderRadius: "50%",
                background: "rgb(14,165,233)",
                display: "inline-block",
              }}
            />
            Cliente
          </h3>
          <div
            style={{
              background: "rgb(248,250,252)",
              borderRadius: "8px",
              padding: "20px",
              border: "1px solid rgb(241,245,249)",
            }}
          >
            <p
              style={{
                margin: "0 0 4px",
                fontWeight: 700,
                fontSize: "16px",
                color: "rgb(15,23,42)",
              }}
            >
              {cliente.nombre}
            </p>
            <p
              style={{
                margin: "0 0 12px",
                fontSize: "14px",
                color: "rgb(100,116,139)",
              }}
            >
              {cliente.contacto}
            </p>
            <div
              style={{
                borderTop: "1px solid rgb(226,232,240)",
                paddingTop: "12px",
                fontSize: "11px",
                color: "rgb(100,116,139)",
                lineHeight: "1.6",
              }}
            >
              <p style={{ margin: 0 }}>{cliente.direccion}</p>
              <p style={{ margin: 0 }}>{cliente.telefono}</p>
              <p style={{ margin: 0 }}>{cliente.email}</p>
            </div>
          </div>
        </div>

        {/* Detalles */}
        <div style={{ width: "256px" }}>
          <h3
            style={{
              margin: "0 0 16px",
              fontSize: "12px",
              fontWeight: 700,
              color: "rgb(148,163,184)",
              textTransform: "uppercase",
              letterSpacing: "0.05em",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <span
              style={{
                width: "8px",
                height: "8px",
                borderRadius: "50%",
                background: "rgb(14,165,233)",
                display: "inline-block",
              }}
            />
            Detalles
          </h3>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "12px" }}
          >
            {[
              {
                label: "Válida hasta",
                value: (
                  <span
                    style={{
                      fontSize: "14px",
                      fontWeight: 600,
                      color: "rgb(15,23,42)",
                    }}
                  >
                    {meta.validez}
                  </span>
                ),
              },
              {
                label: "Estado",
                value: (
                  <span
                    style={{
                      background: "rgb(245,158,11)",
                      color: "#fff",
                      fontSize: "11px",
                      fontWeight: 700,
                      padding: "2px 8px",
                      borderRadius: "4px",
                    }}
                  >
                    {meta.estado}
                  </span>
                ),
              },
              {
                label: "Vendedor",
                value: (
                  <span
                    style={{
                      fontSize: "11px",
                      fontWeight: 500,
                      color: "rgb(15,23,42)",
                    }}
                  >
                    {meta.vendedor}
                  </span>
                ),
              },
            ].map(({ label, value }) => (
              <div
                key={label}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "12px",
                  border: "1px solid rgb(226,232,240)",
                  borderRadius: "6px",
                  background: "#fff",
                }}
              >
                <span style={{ fontSize: "11px", color: "rgb(100,116,139)" }}>
                  {label}
                </span>
                {value}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── Proyecto ── */}
      {meta.proyecto && (
        <div style={{ marginBottom: "32px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              padding: "12px",
              borderRadius: "8px",
              background: "rgb(248,250,252)",
              borderLeft: "4px solid rgb(14,165,233)",
            }}
          >
            <span
              style={{
                fontSize: "11px",
                fontWeight: 700,
                textTransform: "uppercase",
                letterSpacing: "0.1em",
                color: "rgb(100,116,139)",
              }}
            >
              Proyecto:
            </span>
            <span
              style={{
                fontSize: "14px",
                fontWeight: 500,
                color: "rgb(15,23,42)",
              }}
            >
              {meta.proyecto}
            </span>
          </div>
        </div>
      )}

      {/* ── Tabla ── */}
      <div style={{ marginBottom: "40px" }}>
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            fontSize: "13px",
          }}
        >
          <thead>
            <tr style={{ borderBottom: "2px solid rgb(226,232,240)" }}>
              {[
                { label: "SKU", align: "center", width: "80px" },
                { label: "Descripción", align: "left", width: "50%" },
                { label: "Cant", align: "center", width: "70px" },
                { label: "Precio", align: "right", width: "90px" },
                { label: "Total", align: "right", width: "90px" },
              ].map(({ label, align, width }) => (
                <th
                  key={label}
                  style={{
                    padding: "12px 8px",
                    textAlign: align,
                    width,
                    fontSize: "11px",
                    fontWeight: 700,
                    color: "rgb(100,116,139)",
                    textTransform: "uppercase",
                    letterSpacing: "0.1em",
                    background: "#fff",
                  }}
                >
                  {label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {items.map((item, i) => (
              <tr
                key={i}
                style={{ borderBottom: "1px solid rgb(241,245,249)" }}
              >
                <td
                  style={{
                    padding: "16px 8px",
                    fontSize: "11px",
                    color: "rgb(100,116,139)",
                  }}
                >
                  {item.sku}
                </td>
                <td style={{ padding: "16px 8px" }}>
                  <p
                    style={{
                      margin: 0,
                      fontWeight: 500,
                      color: "rgb(15,23,42)",
                      textAlign: "left",
                    }}
                  >
                    {item.descripcion}
                  </p>
                </td>
                <td
                  style={{
                    padding: "16px 8px",
                    textAlign: "center",
                    color: "rgb(100,116,139)",
                  }}
                >
                  {item.cantidad}
                </td>
                <td
                  style={{
                    padding: "16px 8px",
                    textAlign: "right",
                    color: "rgb(100,116,139)",
                  }}
                >
                  {item.precio}
                </td>
                <td
                  style={{
                    padding: "16px 8px",
                    textAlign: "right",
                    fontWeight: 700,
                    color: "rgb(15,23,42)",
                  }}
                >
                  {item.total}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* ── Totales ── */}
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: "48px",
        }}
      >
        <div style={{ width: "320px" }}>
          <div
            style={{
              borderTop: "1px solid rgb(226,232,240)",
              paddingTop: "16px",
              paddingBottom: "16px",
              display: "flex",
              flexDirection: "column",
              gap: "12px",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontSize: "14px",
                color: "rgb(148,163,184)",
              }}
            >
              <span>Subtotal</span>
              <span>{totales.subtotal}</span>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontSize: "14px",
                color: "rgb(148,163,184)",
              }}
            >
              <span>IVA (16%)</span>
              <span>{totales.iva}</span>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "16px",
              borderRadius: "8px",
              background: "rgb(15,23,42)",
              color: "#fff",
              boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            }}
          >
            <span
              style={{
                fontWeight: 700,
                fontSize: "14px",
                textTransform: "uppercase",
                letterSpacing: "0.1em",
              }}
            >
              Total
            </span>
            <span style={{ fontWeight: 700, fontSize: "20px" }}>
              {totales.total}
            </span>
          </div>
        </div>
      </div>

      {/* ── Términos y Notas ── */}
      <div
        style={{
          background: "rgb(248,250,252)",
          borderRadius: "8px",
          padding: "24px",
          fontSize: "11px",
          color: "rgb(100,116,139)",
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "32px",
        }}
      >
        <div>
          <h4
            style={{
              margin: "0 0 8px",
              fontWeight: 700,
              textTransform: "uppercase",
              color: "rgb(15,23,42)",
              fontSize: "11px",
            }}
          >
            Términos
          </h4>
          <p style={{ margin: 0 }}>{terminos}</p>
        </div>
        <div>
          <h4
            style={{
              margin: "0 0 8px",
              fontWeight: 700,
              textTransform: "uppercase",
              color: "rgb(15,23,42)",
              fontSize: "11px",
            }}
          >
            Notas
          </h4>
          <p style={{ margin: 0 }}>{notas}</p>
        </div>
      </div>
    </div>
  );
}
